import { SidePanelContent } from '~/components/sidepanel-section';
import { P2GBox, P2GButton, P2GContainer, P2GText } from '@parcel2go/core-ui';
import { Integration } from '~/lib/api/account-linking/types';
import { OnboardingTitle } from '../rules/onboarding-title';
import { OnboardingActionBar } from '../intro/onboarding-action-bar';
import ECommerceLogo from '~/apps/account-linking/components/ECommerceLogo';
import { AppSurface } from '~/components/surface/app-surface';
import { OnboardingScreenContentWrapper } from '../../OnboardingScreenContentWrapper';

type props = {
  isXs: boolean;
  integration: Integration;
  onDone: () => void;
};

const JustFailedScreen = ({ isXs, integration, onDone }: props) => {
  return (
    <>
      <OnboardingScreenContentWrapper>
        <P2GBox textAlign="center">
          <SidePanelContent>
            <OnboardingTitle
              text={'We couldn’t link your account to <span>{{integration}}</span>'}
              translationKey="SETUP_SALES_CHANNELS_FAILED_TITLE"
              values={{ integration: integration.name }}
            />
          </SidePanelContent>
        </P2GBox>
        <P2GContainer maxWidth="sm">
          <P2GBox mt={4}>
            <ECommerceLogo integration={integration.slug} style={{ height: '70px', maxWidth: '100%' }} />
          </P2GBox>
          <P2GBox mt={4}>
            <AppSurface>
              <P2GText>
                This may happen if you cancelled the linking process, or there was an error during the connection
                attempt.
              </P2GText>
              <P2GBox mt={2}>
                <P2GButton onClick={onDone} variant="primary" size="large">
                  Continue
                </P2GButton>
              </P2GBox>
            </AppSurface>
          </P2GBox>
        </P2GContainer>
      </OnboardingScreenContentWrapper>
      <OnboardingActionBar
        next={
          <P2GButton size="large" onClick={onDone} variant="primary" style={{ minWidth: 'unset' }}>
            Continue
          </P2GButton>
        }
      >
        {!isXs && (
          <P2GText variant="subtitle2">
            Please check your connection settings and try linking your {integration.name} account again.
          </P2GText>
        )}
      </OnboardingActionBar>
    </>
  );
};

export default JustFailedScreen;
